import React from 'react'
import NavBarCandidate from '../components/NavBarCandidate'
import Hero from '../components/CandidateHome/Hero'
import Footer from '../components/Footer'

function CandidateHome() {
  return (
    <div>
        <NavBarCandidate />
        <Hero />
        <Footer />
    </div>
  )
}

export default CandidateHome